import { initAmplitudeBrowser } from "@/wab/client/observability/amplitude-browser";
import { initPosthogBrowser } from "@/wab/client/observability/posthog-browser";
import { initSentryBrowser } from "@/wab/client/observability/sentry-browser";
import { methodForwarder } from "@/wab/commons/methodForwarder";
import { ensure } from "@/wab/shared/common";
import DeploymentFlags from "@/wab/shared/DeploymentFlags";
import type { Analytics } from "@/wab/shared/observability/Analytics";
import { ConsoleLogAnalytics } from "@/wab/shared/observability/ConsoleLogAnalytics";

declare const COMMITHASH: string;

// All of these IDs/keys will be publicly exposed on the frontend.
// Make sure these are all meant to be public.
// TODO: Move to environment variable.
const AMPLITUDE_API_KEY = "1efde847a1dd16e6dbf8a242c1e2dd07";
const POSTHOG_API_KEY = "phc_eaI1hFsPRIZkmwrXaSGRNDh4H9J3xdh1j9rgNy27NgP";
const POSTHOG_API_HOST = "https://us.i.posthog.com";
const SENTRY_ORG_ID = "plasmicapp";
const SENTRY_PROJECT_ID = 1840236;
const SENTRY_DSN = `https://5dcf8b50996ebfd2de4813d303f8ec66@sentry.io/${SENTRY_PROJECT_ID}`;

let globalAnalytics: Analytics;

export function analytics(): Analytics {
  return globalAnalytics;
}

export function initObservability(): void {
  ensure(
    globalAnalytics === undefined,
    "Cannot initialize observability twice"
  );

  const production = DeploymentFlags.DEPLOYENV === "production";
  const commitHash = COMMITHASH;

  const amplitudeAnalytics = initAmplitudeBrowser({
    apiKey: AMPLITUDE_API_KEY,
  });
  const posthogAnalytics = initPosthogBrowser({
    apiKey: POSTHOG_API_KEY,
    apiHost: POSTHOG_API_HOST,
    config: {},
  });

  globalAnalytics = production
    ? methodForwarder(amplitudeAnalytics, posthogAnalytics)
    : methodForwarder(
        new ConsoleLogAnalytics(),
        amplitudeAnalytics,
        posthogAnalytics
      );
  globalAnalytics.appendBaseEventProperties({
    production,
    commitHash,
  });

  initSentryBrowser({
    production,
    commitHash,
    dsn: SENTRY_DSN,
    orgId: SENTRY_ORG_ID,
    projId: SENTRY_PROJECT_ID,
    posthogAnalytics,
  });
}

export const _testonly = {
  setGlobalAnalytics: (testAnalytics: Analytics) => {
    globalAnalytics = testAnalytics;
  },
};
